export { TableOfContents, WrapperIndex } from './TableOfContents';
